import { _t } from 'app/utils/i18n';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email(_t('basic:wrong_email'))
    .required(_t('basic:This_field_is_mandatory')),
  password: Yup.string().required(_t('basic:This_field_is_mandatory')),
});
